export function redirectToHref(path: string): void {
	window.parent.location.href = path
}

export function getHref(): string {
	return window.parent.location.href
}

export function getQueryParam(queryParam: string): string {
	return new URLSearchParams(window.location.search).get(queryParam)
}

export function getHostName(): string {
	return window.location.hostname
}

export function getSearch(): string {
	return window.location.search
}
